import { BasketItem } from '@src/hooks/useBasketItems/validation'

import { basketItemsVar } from '../utils/reactiveVar'
import { HookMethodArgs } from '../utils/types'

export const updateQuantities =
  ({ existingItems, navigateToBasket, updateBasketOutletId }: HookMethodArgs) =>
  ({
    basketItemUpdates,
    shouldNavigateToBasket = true,
  }: {
    basketItemUpdates: {
      basketItemId: string
      quantity: number
    }[]
    shouldNavigateToBasket?: boolean
  }): void => {
    const existingBasketItemsWithUpdateData = basketItemUpdates.map(
      ({ basketItemId, quantity }) => {
        const basketItemIndex = existingItems.findIndex(
          basketItem => basketItem.id === basketItemId
        )
        const basketItem = existingItems[basketItemIndex]
        if (!basketItem) {
          throw new Error('Error updating basket: basket item not found.')
        }

        // if the quantity is 0 set to null for removal
        // otherwise update the quantity
        return {
          basketItemIndex,
          updatedBasketItem:
            quantity === 0 ? null : { ...basketItem, quantity },
        }
      }
    )

    // clone existing state array
    const clonedBasketItems: Array<BasketItem | null> = [...existingItems]
    // iterate through the updates overriding the item
    for (const existingBasketItemWithUpdateData of existingBasketItemsWithUpdateData) {
      const { basketItemIndex, updatedBasketItem } =
        existingBasketItemWithUpdateData

      clonedBasketItems[basketItemIndex] = updatedBasketItem
    }

    // update the reactive var with the new state (after filtering out nulls)
    const updatedBasketItems = clonedBasketItems.filter(
      (basketItem): basketItem is BasketItem => basketItem !== null
    )
    basketItemsVar(updatedBasketItems)

    if (shouldNavigateToBasket) {
      // navigate back to the basket
      navigateToBasket()
    }

    if (updatedBasketItems.length === 0) {
      updateBasketOutletId(null)
    }
  }
